/* src/app/intern/intern-details/observations/mentor/mentor-observation-documents/mentor-observation-documents.component.scss */
.container {
  min-width: 400px;
}
.title {
  text-align: left;
  font-size: 18px;
  background-color: #F4F0E5;
  color: black;
  margin: 1rem auto;
  padding: 10px;
  height: fit-content;
}
.document-upload-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.document-upload-row .filename {
  width: 250px;
  text-align: left;
  display: inline-block;
  margin: 0 25px 0 5px;
  overflow-x: hidden;
  padding: 9px 0 0 0;
}
.document-upload-row .no-document-message {
  color: #B62A39;
}
.document-upload-row button {
  width: 104px;
}
.mat-icon {
  font-size: 22px;
}
.action-button {
  border-radius: 22px;
  float: right;
}
.file-input {
  display: none;
}
a.customLink {
  text-decoration: underline;
  color: blue;
  cursor: pointer;
  font-size: 14px;
  margin-right: 25px;
  margin-left: 5px;
  display: inline-block;
  padding: 9px 0 0 0;
}
/*# sourceMappingURL=mentor-observation-documents.component.css.map */
